import { ReactNode } from 'react';
import { HeadingLevel as ZinniaHeadingLevel } from '@zapier/design-system';

export interface HeadingLevelProps {
  children: ReactNode;
}

export function HeadingLevel({ children }: HeadingLevelProps) {
  return <ZinniaHeadingLevel>{children}</ZinniaHeadingLevel>;
}
